<template>
    <div id="app">
        <!-- 路由出口,路由匹配到的组件将渲染在这里,没有这个页面将无法渲染出来 -->
        <router-view></router-view>
    </div>
</template>

<script>
// import DevicePixelRatio from "./utils/devicePixelRatio";

export default {
    name: 'app',
    data() {
        return {
        }
    },
    components: {},
    methods: {

    },
    created() {
        // new DevicePixelRatio().init();

    },
    mounted() {

    },

}
</script>

<!--去掉默认样式-->
<style lang="less">
html,
body,
h3,
p {
    margin: 0;
    padding: 0;
}

//设置全局的弹窗对话框的边框和阴影
.el-dialog {
    pointer-events: auto;
    border: 2px solid #409EFF;
    /* 自定义边框颜色和宽度 */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
    /* 自定义阴影样式 */
}
</style>
